/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// @ts-nocheck

/**
 * BrowsingModeDetector
 *
 * @returns {BrowsingModeDetector}
 * @constructor
 * @author Maykonn Welington Candido <maykonn@outlook.com>
 */
const BrowsingModeDetector = function () {
  let _browsingInIncognitoMode;

  this.BROWSING_NORMAL_MODE = false;
  this.BROWSING_INCOGNITO_PRIVATE_MODE = true;

  this.getBrowsingMode = function () {
    return _browsingInIncognitoMode ? this.BROWSING_INCOGNITO_PRIVATE_MODE : this.BROWSING_NORMAL_MODE;
  };

  this.setBrowsingInIncognitoMode = function () {
    _browsingInIncognitoMode = true;
  };

  this.setBrowsingInNormalMode = function () {
    _browsingInIncognitoMode = false;
  };

  /**
   * @param defaultCallback optional
   */
  this.do = function (defaultCallback) {
    new BrowserFactory().browser(this).detectBrowsingMode(defaultCallback);
  };

  return this;
};

/**
 * @returns {BrowserFactory}
 * @constructor
 */
var BrowserFactory = function () {
  let _browser;

  this.browser = function (BrowsingModeDetector) {
    if (typeof _browser === 'object') {
      return _browser;
    }

    return (_browser = _resolve(BrowsingModeDetector));
  };

  /**
   * @param {BrowsingModeDetector} BrowsingModeDetector
   * @returns {*}
   * @private
   */
  var _resolve = function (BrowsingModeDetector) {
    if (/constructor/i.test(window.HTMLElement) || (navigator.vendor && navigator.vendor.indexOf('Apple') > -1)) {
      return new SafariBrowser(BrowsingModeDetector);
    } else if ('MozAppearance' in document.documentElement.style) {
      return new MozillaBrowser(BrowsingModeDetector);
    } else if (window.webkitRequestFileSystem) {
      return new WebkitBrowser(BrowsingModeDetector);
    } else if (window.PointerEvent || window.MSPointerEvent) {
      return new IE10EdgeBrowser(BrowsingModeDetector);
    } else {
      return new OtherBrowser(BrowsingModeDetector);
    }
  };

  return this;
};

/**
 * @param {BrowsingModeDetector} BrowsingModeDetector
 * @returns {WebkitBrowser}
 * @constructor
 */
var WebkitBrowser = function (BrowsingModeDetector) {
  const self = this;
  this.STORAGE_QUOTA_LIMIT = 120000000; // There’s a hard limit of 120MB while this is not the case for non-incognito window
  this.TEMP_STORAGE_QUOTA_LIMIT = 110000000; // There’s a hard limit of 110MB while this is not the case for non-incognito window
  this.BrowsingModeDetector = BrowsingModeDetector;

  this.detectBrowsingMode = function (_executeUserCallback) {
    const callbackWhenWebkitTemporaryStorageQuotaNotLimited = function () {
      self.BrowsingModeDetector.setBrowsingInNormalMode();
      _executeUserCallback();
      return;
    };

    const callbackWhenWebkitTemporaryStorageQuotaLimited = function () {
      self.BrowsingModeDetector.setBrowsingInIncognitoMode();
      _executeUserCallback();
      return;
    };

    const checkWebkitTemporaryStorageQuota = function () {
      if (
        typeof navigator.webkitTemporaryStorage != 'undefined' &&
        typeof navigator.webkitTemporaryStorage.queryUsageAndQuota != 'undefined'
      ) {
        navigator.webkitTemporaryStorage.queryUsageAndQuota(
          function (usedBytes, grantedBytes) {
            if (grantedBytes < self.TEMP_STORAGE_QUOTA_LIMIT) {
              callbackWhenWebkitTemporaryStorageQuotaLimited();
            } else {
              callbackWhenWebkitTemporaryStorageQuotaNotLimited();
            }
          },
          function () {
            callbackWhenWebkitTemporaryStorageQuotaNotLimited();
          }
        );
      } else {
        callbackWhenWebkitTemporaryStorageQuotaNotLimited();
      }
    };

    const callbackWhenWebkitStorageQuotaNotLimited = function () {
      checkWebkitTemporaryStorageQuota();
      return;
    };

    const callbackWhenWebkitStorageQuotaLimited = function () {
      self.BrowsingModeDetector.setBrowsingInIncognitoMode();
      _executeUserCallback();
      return;
    };

    const checkStorageQuota = function () {
      if (typeof navigator.storage != 'undefined' && typeof navigator.storage.estimate != 'undefined') {
        navigator.storage.estimate().then(function (estimate) {
          if (estimate.quota < self.STORAGE_QUOTA_LIMIT) {
            callbackWhenWebkitStorageQuotaLimited();
          } else {
            callbackWhenWebkitStorageQuotaNotLimited();
          }
        });
      } else {
        callbackWhenWebkitStorageQuotaNotLimited();
      }
    };

    // The window.webkitRequestFileSystem() is not accessible on Chrome 78
    checkStorageQuota();
  };

  return this;
};

/**
 * @param {BrowsingModeDetector} BrowsingModeDetector
 * @returns {MozillaBrowser}
 * @constructor
 */
var MozillaBrowser = function (BrowsingModeDetector) {
  this.BrowsingModeDetector = BrowsingModeDetector;

  this.detectBrowsingMode = function (_executeUserCallback) {
    const self = this;

    const callbackWhenIndexedDBSuccess = function () {
      self.BrowsingModeDetector.setBrowsingInNormalMode();
      _executeUserCallback();
      return;
    };

    const callbackWhenIndexedDBError = function () {
      self.BrowsingModeDetector.setBrowsingInIncognitoMode();
      _executeUserCallback();
      return;
    };

    window.tempIndexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
    if (window.tempIndexedDB) {
      const req = window.tempIndexedDB.open('test');
      req.onerror = function () {
        callbackWhenIndexedDBError();
      };
      req.onsuccess = function () {
        callbackWhenIndexedDBSuccess();
      };
    }
  };

  return this;
};

/**
 * @param {BrowsingModeDetector} BrowsingModeDetector
 * @returns {SafariBrowser}
 * @constructor
 */
var SafariBrowser = function (BrowsingModeDetector) {
  this.BrowsingModeDetector = BrowsingModeDetector;

  this.detectBrowsingMode = function (_executeUserCallback) {
    // From https://github.com/jLynx/PrivateWindowCheck
    if (window.safariIncognito) {
      this.BrowsingModeDetector.setBrowsingInIncognitoMode();
      _executeUserCallback();
      return;
    }
    // iOS 11
    // From gist discussion: https://gist.github.com/cou929/7973956#gistcomment-2272103 and
    // https://github.com/jLynx/PrivateWindowCheck
    try {
      window.openDatabase(null, null, null, null);
      window.localStorage.setItem('test', 1);
    } catch (e) {
      this.BrowsingModeDetector.setBrowsingInIncognitoMode();
      _executeUserCallback();
      return;
    }

    // Older Safari
    try {
      if (!localStorage.length) {
        localStorage.i = 1;
        localStorage.removeItem('i');
      }
      this.BrowsingModeDetector.setBrowsingInNormalMode();
    } catch (e) {
      // From: https://gist.github.com/jherax/a81c8c132d09cc354a0e2cb911841ff1
      // Safari only enables cookie in private mode
      // if cookie is disabled then all client side storage is disabled
      // if all client side storage is disabled, then there is no point
      // in using private mode
      if (navigator.cookieEnabled) {
        this.BrowsingModeDetector.setBrowsingInIncognitoMode();
      } else {
        this.BrowsingModeDetector.setBrowsingInNormalMode();
      }
    }

    _executeUserCallback();
    return;
  };

  return this;
};

/**
 * @param {BrowsingModeDetector} BrowsingModeDetector
 * @returns {IE10EdgeBrowser}
 * @constructor
 */
var IE10EdgeBrowser = function (BrowsingModeDetector) {
  this.BrowsingModeDetector = BrowsingModeDetector;

  this.detectBrowsingMode = function (_executeUserCallback) {
    if (window.indexedDB) {
      this.BrowsingModeDetector.setBrowsingInNormalMode();
    } else {
      this.BrowsingModeDetector.setBrowsingInIncognitoMode();
    }
    _executeUserCallback();
  };

  return this;
};

/**
 * @param {BrowsingModeDetector} BrowsingModeDetector
 * @returns {OtherBrowser}
 * @constructor
 */
var OtherBrowser = function (BrowsingModeDetector) {
  this.BrowsingModeDetector = BrowsingModeDetector;

  this.detectBrowsingMode = function (_executeUserCallback) {
    this.BrowsingModeDetector.setBrowsingInNormalMode();
    _executeUserCallback();
  };

  return this;
};

const isPrivateMode = () => {
  return new Promise((resolve) => {
    const bmd = new BrowsingModeDetector();
    bmd.do(() => resolve(bmd.getBrowsingMode()));
  });
};

export default isPrivateMode;
